/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

import { AbortError } from '@amazon/vinyl-util'

// Provider-neutral helpers shared across the agent layer. These are NOT part
// of the transport contract (that lives in `transport.ts`) — they are plain
// utilities every provider adapter and the accumulator reach for, so they sit
// beside the contract rather than inside it.

/**
 * Mint a unique correlation id — an adapter uses it for the wire request id,
 * the accumulator for the (stable-per-turn) message id. Both are opaque and
 * never compared across the seam, so they may be independently generated.
 */
export function generateRequestId(): string {
    return `req-${Date.now()}-${Math.floor(Math.random() * 100_000)}`
}

// True for both the native DOMException (fetch via `nativeSignal`) and
// Vinyl's `AbortError` (raised by `Abort`). Shared by the agent-layer
// modules so a cancel is treated identically wherever a turn tears down.
export function isAbortError(err: unknown): boolean {
    return err instanceof AbortError || (err instanceof Error && err.name === 'AbortError')
}
